import { useUser } from 'hooks/useUser';

export const useCancelledClientsCount = (): number => {
  const user = useUser();

  if (user?.cancelledClientsCount) {
    return user.cancelledClientsCount;
  }

  return 0;
};
